import axiosInstance from "../../api/axiosInstance";

export const fetchLatestAppVersionAPI = async (platform) => {
  const res = await axiosInstance.get(`app-version?platform=${platform}`);
  return res.data;
};

export const createAppVersionAPI = async (payload) => {
  const res = await axiosInstance.post("app-version", payload);
  return res.data.version;
};
